import React from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Collapse, Table, TableBody, TableCell, TableRow } from '@mui/material';
import IconButton from '@mui/material/IconButton';

export const TablePanelRow = ({
    data,
    collapsibleData = [],
    config,
    rowClasses,
    rowColumnStyle,
    defaultStyles,
    collapsibleConfig,
    ...props
}) => {
    const [open, setOpen] = React.useState(false);
    return (
        <React.Fragment>
            <TableRow classess={rowClasses} {...props}>
                {collapsibleConfig && (
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                )}
                {config.map((c, j) => (
                    <TableCell
                        key={'tr-' + '-' + j}
                        variant="body"
                        component="th"
                        scope="row"
                        style={Object.assign({ maxWidth: c.width }, rowColumnStyle, c.style, defaultStyles)}
                    >
                        {typeof c.field === 'function' ? c.field(data) : data[c.field]}
                    </TableCell>
                ))}
            </TableRow>
            {collapsibleConfig && (
                <TableRow>
                    <TableCell
                        style={{
                            paddingBottom: 0,
                            paddingTop: 0,
                            paddingLeft: 65,
                            borderBottom: 'none'
                        }}
                        colSpan={9}
                    >
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box margin={1}>
                                <Table aria-label="collapsible">
                                    <TableBody>
                                        {collapsibleData.map((item, index) => (
                                            <TableRow key={index}>
                                                {collapsibleConfig.map((conf, index) => (
                                                    <TableCell key={index} component="th" scope="row">
                                                        {typeof conf.field === 'function'
                                                            ? conf.field(item)
                                                            : item[conf.field]}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            )}
        </React.Fragment>
    );
};
